import { useNavigate, useParams } from 'react-router-dom'
import {
  useAccountId,
  useCurrentCloudProvider,
  SelectedCloudIcon,
  useGetAllUsers,
  useUserType,
  HeaderRoutingApp,
} from '@labrav/common'
import { ResellerAuthorizationCreation } from './ResellerAuthorizationCreation/ResellerAuthorizationCreation'
import { useStyles } from './AddEditResellerAuthorization.styles'
import { useEffect } from 'react'
import { clearResaleAuthorizationInCreation } from '../../modules/resaleAuthorization/action'
import { useDispatch } from '../../store'
import { useSyncFlyoutRouteParams } from '../../common/utils/hooks/useSyncFlyoutRouteParams'
import { EditResaleAuthorizationWrapperV2 } from '../ResaleAuthorizationV2/EditResaleAuthorizationWrapperV2'

export const AddEditResellerAuthorization = () => {
  // Sync route params to selectedAccountIds for FLYOUT
  useSyncFlyoutRouteParams()

  const cloudMarketplace = useCurrentCloudProvider()
  const navigate = useNavigate()
  const { classes } = useStyles()
  const dispatch = useDispatch()
  const partnerType = useUserType()
  const { users } = useGetAllUsers(partnerType)
  const { productId = '' } = useParams<{
    productId: string
  }>()
  const { accountId: routeAccountId, cloud: routeCloud } = useParams<{
    cloud: string
    accountId: string
  }>()
  const fallbackAccountId = useAccountId({ product: 'flyout' }) || ''
  const accountId = routeAccountId || fallbackAccountId

  const onBack = () => {
    navigate(`/flyout/${routeCloud}/${accountId}/reseller-authorizations/sent`)
  }
  useEffect(() => {
    return () => {
      dispatch(clearResaleAuthorizationInCreation(productId))
    }
  }, [productId])

  return (
    <div>
      <div className={classes.headerContainer}>
        <HeaderRoutingApp
          title={`Create a Reseller authorization ${cloudMarketplace === 'AZURE' ? '(Multiparty offer)' : ''}`}
          actions={SelectedCloudIcon}
          isBack={true}
          onBack={onBack}
        />
      </div>

      {cloudMarketplace === 'AZURE' && (
        <ResellerAuthorizationCreation users={users} />
      )}
      {cloudMarketplace === 'AWS' && (
        <EditResaleAuthorizationWrapperV2 users={users} />
      )}
    </div>
  )
}
